export const container='flex items-center justify-center min-h-screen w-full'
export const cardContainer= "w-full md:w-3/5 mx-4"
export const card='rounded-none'
export const button ='bg-custom-button-green'
export const buttomDiv= 'my-2 text-center'
export const buttomDivPara ='text-green-800 text-sm font-bold'
